import { LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT } from "../actions"
import { UserDetail } from "../../CommonTypes"

const user: UserDetail = JSON.parse(localStorage.getItem("user") as string)

const initialState = user ? { isLoggedIn: true, user } : { isLoggedIn: false, user: null }

export const auth = (state = initialState, action: any) => {
  const { type, payload } = action

  switch (type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        user: payload.user,
      }
    case "NOTIFY_SUCCESS":
      return {
        ...state,
        type: "success",
        message: payload.message,
      }
    case LOGIN_FAIL:
      return {
        ...state,
        isLoggedIn: false,
        user: null,
      }
    case LOGOUT:
      return {
        ...state,
        isLoggedIn: false,
        user: null
      }
    default:
      return state
  }
}
